import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const prepaidCardGroupDefinitionStyle = {
	...customCheckboxRadioSwitch
};

export default prepaidCardGroupDefinitionStyle;
